import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "../../avipam/styled.css";

//component
import BodyCard from "../../../components/bodyCard";
const alternatives = [
  { name: "mais de 500", isCorrect: false },
  { name: "mais de 1000", isCorrect: false },
  { name: "mais de 400", isCorrect: false },
  { name: "mais de 300", isCorrect: true },
]

export default function AvipamEnquete6() {
  const [user, setUser] = useState();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (window.location.search !== "") {
      const idEvent = searchParams.get("idEvent");
      const idPart = searchParams.get("idPart");

      setUser({
        idEvent: idEvent,
        idPart: idPart,
      });
    }
  }, []);
  return (
    <div className="section-files">
      <div className="div-files">
        <BodyCard
          user={user}
          type={"Enquete 6"}
          fileName="Enquete6"
          title={"Quantos colaboradores temos aproximadamente na AVIPAM?"}
          alternatives={alternatives}
          description={[{ data: "" }]}
          id={"47c6eef5-314a-429e-ab1f-a4f7352e4dbb"}
          button={"Enviar"}
          codeRanking="ENQUETE6-EXTERNO"
        />
      </div>
    </div>
  );
}
